import 'document-register-element/build/document-register-element'
import Vue from 'vue'
import VueCookie from 'vue-cookie'
import VueMq from 'vue-mq'

import Lottie from "vue-lottie";
Vue.component("lottie", Lottie);

import VueCustomElement from 'vue-custom-element'
Vue.use(VueCustomElement)
Vue.use(VueCookie);

Vue.use(VueMq, {
  breakpoints: {
    mobile: 450,
    tablet: 900,
    desktop: Infinity,
  }
})

import Wrapper from './components/Wrapper'
Vue.customElement('imbee-chat', Wrapper);



// WEBPACK FOOTER //
// ./src/main.js